module.exports = __webpack_public_path__ + "media/images/company/cp02-c3b8eabbf881f97f922b0d5ccd9579ff.png";